<div class="content">
  <div class="sidebar standard-listing">
    <div class="header title-and-buttons">
      <div class="title-bar">
        <span class="title">Providers</span>
        <div class="buttons">
          <button #infoButton mat-button class="button info" title="Info" (click)="showInfoPopover()">
            <img src="assets/ic_information_blk.svg" class="icon" />
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="isLoading()" class="listings">
      <listing-component *ngFor="let listing of [1,2,3,4,5,6,7,8,9]" [skeleton]="true"></listing-component>
    </div>
    <div *ngIf="!isLoading() && savedObjects.length == 0" class="empty-state">
      Nothing to show
    </div>
    <div *ngIf="!isLoading() && savedObjects.length > 0" class="listings">
      <listing-component *ngFor="let provider of savedObjects" [title]="provider.getListingName()"
        [desc]="provider.description.savedValue" [selected]="isSelected(provider)"
        [isDirty]="provider.isDirty()" [hasError]="provider.hasVisibleIssue()" (click)="select(provider)"></listing-component>
    </div>
    <!-- <button mat-icon-button *ngIf="!isLoading()" class="circle-button" title="Add a new provider" (click)="addSavedObject()">
      <img src="assets/content-icon/ic-04.svg" />
    </button> -->
  </div>
  <div class="body" *ngVar="getSelected() as selected">
    <div *ngIf="isLoading()" class="body-content skeleton">
      <div class="page-title-container"><span class="page-title skeleton-animation"></span></div>
      <div class="fields skeleton">
        <div class="input-area">
          <div class="input-container">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
          <div class="input-container">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
          <div class="input-container double">
            <span class="label skeleton-animation"></span>
            <div class="input skeleton-animation"></div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button mat-button class="text-button secondary" disabled>Delete</button>
        <button mat-button class="text-button" disabled>Save</button>
      </div>
    </div>
    <div class="body-content" *ngIf="!(isLoading() || selected)">
      <div class="page-empty-state-area">
        <img src="assets/empty-state/journal_empty_filter.svg" class="empty-state-image">
        <span class="title">{{getEmptyStateTitle()}}</span>
        <span class="desc">{{getEmptyStateDesc()}}</span>
        <button mat-button class="add-button centered-button" (click)="addSavedObject()">
          <img src="assets/content-icon/ic-04.svg" />
          <span class="text">Add</span>
        </button>
      </div>
    </div>
    <div *ngIf="!isLoading() && selected" class="body-content">
      <div class="page-title-container"><span class="page-title">{{selected.getListingName()}}</span></div>
      <div class="tabs">
        <button mat-button class="body-standard-tab"
                [ngClass]="{selected: selectedTab == 'general'}"
                (click)="selectedTab = 'general'"><span class="text">
              General Settings
            </span>
          <div class="dot"></div>
        </button>
        <button mat-button class="body-standard-tab"
                [ngClass]="{selected: selectedTab == 'users'}"
                (click)="selectedTab = 'users'"><span class="text">
              Users
            </span>
          <div class="dot"></div>
        </button>
        <div *ngIf="isCommunity()" >
          <button mat-button class="body-standard-tab"
          [ngClass]="{selected: selectedTab == 'services'}"
                  (click)="selectedTab = 'services'"><span class="text">
                Service Levels
              </span>
            <div class="dot"></div>
          </button>   
        </div> 
        <button mat-button class="body-standard-tab"
                [ngClass]="{selected: selectedTab == 'practitioner'}"
                (click)="selectedTab = 'practitioner'"><span class="text">
              Teams
            </span>
          <div class="dot"></div>
        </button>
        <div *ngIf="isMottHaven" >
          <button mat-button class="body-standard-tab"
                  [ngClass]="{selected: selectedTab == 'buildings'}"
                  (click)="selectedTab = 'buildings'"><span class="text">
                Buildings
              </span>
            <div class="dot"></div>
          </button>
        </div>
        <button mat-button class="body-standard-tab"
                [ngClass]="{selected: selectedTab == 'documents'}"
                (click)="selectedTab = 'documents'"><span class="text">
               Documents
            </span>
          <div class="dot"></div>
        </button>  
        <button mat-button class="body-standard-tab"
                [ngClass]="{selected: selectedTab == 'evaluations'}"
                (click)="selectedTab = 'evaluations'"><span class="text">
              Evaluations
            </span>
          <div class="dot"></div>
        </button>  
        <div *ngIf="isUserPRSAdmin()" >
          <button mat-button class="body-standard-tab"
          [ngClass]="{selected: selectedTab == 'endpoints'}"
                  (click)="selectedTab = 'endpoints'"><span class="text">
                Provider Endpoints
              </span>
            <div class="dot"></div>
          </button>   
        </div>    
      </div>
      <div *ngIf="selectedTab == 'general'">
          <div class="fields">
            <div class="input-area">
              <div class="input-container" *ngVar="selected.name as field" [title]="field.isEditable() ? '' : field.value"
                [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
                <div class="label-line">
                  <span class="label">Provider Name</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'The name of the provider.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <input #autofocus type="text" class="input" maxlength="128" placeholder="Provider Name" (blur)="field.touch()"
                  [(ngModel)]="field.value" [disabled]="!field.isEditable()" />
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
              <div class="input-container" *ngVar="selected.private as field"
                [title]="field.isEditable() ? '' : field.getDisplayValue()"
                [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
                <div class="label-line">
                  <span class="label">Private and Protected Only</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'Makes the provider accessible only to you and other designated users.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <mat-select class="input select" placeholder="Private and Protected Only" (openedChange)="field.openedChange($event)"
                  (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!field.isEditable()">
                  <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                    {{option.displayValue}}
                  </mat-option>
                </mat-select>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
              <div class="input-container double" *ngVar="selected.description as field"
                [title]="field.isEditable() ? '' : field.value"
                [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
                <div class="label-line">
                  <span class="label">Description</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'The description of the provider.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <div class="input-inner-container">
                  <label for="description" class="hitbox text"></label>
                  <textarea textareaAutoheight id="description" class="input tall" maxlength="255" placeholder="Description"
                    (blur)="field.touch()" [(ngModel)]="field.value" [disabled]="!field.isEditable()"></textarea>
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="canCleanProvider()">
              <provider-cleaner [providers]="savedObjects"></provider-cleaner>
          </div>
      </div>
        <div *ngIf="selectedTab == 'users'" class="fields">
          <div *ngIf="!selected.isNew()" class="double">
            <div class="subheader-line" *ngVar="selected.usersGroup as group"
              [ngClass]="{dirty: group.isDirty() && !selected.isNew(), error: group.hasVisibleIssue()}">
              <div class="subheader-text">
                <span class="subheader">Users<span *ngIf="!selected.isNew()" [ngClass]="{invalid: selected.userStatusField.getDisplayedIssue()}"> {{selected.seatDependency.getSum()}}/{{selected.seatCount}}</span></span>
                <div class="dot"></div>
                <button mat-button class="text-button label-info-button" title="Info"
                  (click)="showFieldInfo($event, 'The users involved with this provider.')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <button [disabled]="selected.seatDependency.getSum() >= selected.seatCount" mat-button class="text-button subheader-button" (click)="selected.addUser(); setShouldScrollToNew()">
                <img src="assets/content-icon/ic-04.svg" class="icon" />
              </button>
            </div>
            <div *ngIf="selected.users.length == 0" class="empty-state"
              [ngClass]="{error: selected.userStatusField.getDisplayedIssue()}">
              {{selected.userStatusField.getDisplayedIssue() || 'Nothing to show'}}
            </div>
            <div (ngInit)="scrollToNew($event)" class="card input-area" *ngFor="let user of selected.users; index as i"
              [ngClass]="{dirty: user.isDirty() || (selected.isDirty() && user.isNew), invalid: user.hasVisibleIssue()}">
              <button mat-button class="text-button corner-button"
                (click)="selected.removeUser(i); selected.userStatusField.touch();">
                <img src="assets/content-icon/ic-05.svg" class="icon" />
              </button>
              <div class="input-container double" *ngVar="user.email as field" [title]="field.isEditable() ? '' : field.value"
                [ngClass]="{error: field.getDisplayedIssue(), dirty: !user.isNew && field.isDirty()}">
                <div class="label-line">
                  <span class="label">Email</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'The user\'s email.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <input type="text" class="input" maxlength="100" placeholder="Email" (blur)="field.touch()"
                  [(ngModel)]="field.value" [disabled]="!field.isEditable()" />
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
              <div class="input-container" *ngVar="user.userRole as field"
                [title]="field.isEditable() ? '' : field.getDisplayValue()"
                [ngClass]="{error: field.getDisplayedIssue(), dirty: !user.isNew && field.isDirty()}">
                <div class="label-line">
                  <span class="label">Compass Role</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'The user\'s role in building compasses.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <mat-select class="input select" placeholder="Role" (openedChange)="field.openedChange($event)"
                  (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!field.isEditable()">
                  <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                    {{option.displayValue}}
                  </mat-option>
                </mat-select>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
              <div class="input-container" *ngVar="user.active as field"
                [title]="field.isEditable() ? '' : field.getDisplayValue()"
                [ngClass]="{error: field.getDisplayedIssue(), dirty: !user.isNew && field.isDirty()}">
                <div class="label-line">
                  <span class="label">Active</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'Determines whether the user can see compasses for this provider in CompassBuilder.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <mat-select class="input select" placeholder="Active" (openedChange)="field.openedChange($event)"
                  (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="!field.isEditable()">
                  <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                    {{option.displayValue}}
                  </mat-option>
                </mat-select>
                <span class="error-message">{{field.getDisplayedIssue()}}</span>
              </div>
              <div *ngIf="user.shouldShowNames()" class="input-container" [title]="user.firstName">
                <div class="label-line">
                  <span class="label">First Name</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'The user\'s first name.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <input type="text" class="input" maxlength="50" placeholder="First Name" [ngModel]="user.firstName" disabled />
              </div>
              <div *ngIf="user.shouldShowNames()" class="input-container" [title]="user.lastName">
                <div class="label-line">
                  <span class="label">Last Name</span>
                  <div class="dirty-dot"></div>
                  <button mat-button class="text-button label-info-button" title="Info"
                    (click)="showFieldInfo($event, 'The user\'s last name.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <input type="text" class="input" maxlength="50" placeholder="Last Name" [ngModel]="user.lastName" disabled />
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="selectedTab == 'practitioner'" class="fields">
          <!-- Need: Practitioner Group Name, Description, Provider ID, Created By, Users -->
          <practitioner-groups [provider]="selected"></practitioner-groups>
        </div>
        <div *ngIf="selectedTab == 'documents'" class="fields">
          <documents [contextId]="selected.id" contextType="PROVIDER"></documents>
        </div>
        <div *ngIf="selectedTab == 'endpoints'" class="fields">
          <provider-endpoints></provider-endpoints>
        </div>
        <div *ngIf="selectedTab == 'services'" class="fields">
          <service-levels [provider]="selected"></service-levels>
        </div>
        <div *ngIf="selectedTab == 'buildings'" class="fields">
          <buildings [provider]="selected"></buildings>
        </div>
        <div *ngIf="selectedTab == 'checklistTemplates'" class="fields">
          <checklist-templates [provider]="selected"></checklist-templates>
        </div>
        <div *ngIf="selectedTab == 'evaluations'" class="fields">
          <evaluations [provider]="selected"></evaluations>
        </div>
      <div class="buttons" *ngIf="selectedTab != 'buildings' && selectedTab != 'practitioner' && selectedTab != 'documents' && selectedTab != 'checklistTemplates' && selectedTab != 'evaluations' && selectedTab != 'services'" >
        <mat-progress-spinner *ngIf="selected.isSaving()" class="spinner" color="primary" mode="indeterminate"
          diameter="21">
        </mat-progress-spinner>
        <button mat-button class="text-button secondary shy" [disabled]="!selected.discardEnabled()"
          (click)="selected.reset()">Discard changes</button>
        <button mat-button class="text-button secondary" [disabled]="!selected.deleteEnabled()" (click)="selected.delete()">Delete</button>
        <button mat-button class="text-button" [disabled]="!selected.saveEnabled()"
          (click)="selected.save()">Save</button>
      </div>
    </div>
  </div>
  <div class="backdrop" [ngClass]="{showing: infoPopoverShowing}" (click)="hideInfoPopover()"></div>
  <div #popover class="popover fixed-arrow" [ngClass]="{showing: infoPopoverShowing}"
    [style]="getInfoPopoverPosition()">
    <div class="popover-content">
      <div class="header">Header</div>
      <div class="subheader">Subheader 1</div>
      <div class="text">Text 1</div>
      <div class="subheader">Subheader 2</div>
      <div class="text">Text 2</div>
      <div class="subheader">Subheader 3</div>
      <div class="text">Tex 3</div>
    </div>
  </div>
</div>
<div class="backdrop" [ngClass]="{showing: fieldInfoShowing}" (click)="hideFieldInfo()">
  <div #fieldInfo class="popover" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoPosition"
    (click)="$event.stopPropagation()">
    <div class="popover-content">
      <div class="text"></div>
    </div>
  </div>
  <div class="popover-arrow" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoArrowPosition"></div>
</div>
